<template>
	<div>
		<section>
			<span class="chooseInfo">{{$t('retailInstance.text.chooseInfo',[multipleSelection.length])}}</span>
			<span @click="collapseTable" v-if="showDifferent.hasCollapse">
				<a href="javascript:void(0)">{{this.isCollapseTable?$t('privateNetInstance.putaway'):$t('privateNetInstance.showDetails')}}</a></span>
		</section>
		<el-table :data="multipleSelection"
			v-show="isCollapseTable"
			style="width: 100%;"
			max-height="242"
			class="bind-flex-net jc-table"
			border>
			<el-table-column
				:show-overflow-tooltip="true"
				:label="$t('privateNetInstance.instanceID')">
				<template slot-scope="scope">
					<span>{{ scope.row.instanceId }}</span>
				</template>
			</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				:label="$t('privateNetInstance.instanceName')">
				<template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				</template>
			</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				:label="showDifferent.ipLabelType === 'mainIp'? $t('listPage.tableLabel.targetIpAddress') : $t('list.ip')">
				<template slot-scope="scope">
					<span>{{ scope.row.privateIp + $t('privateNetInstance.private')}}</span>
				</template>
			</el-table-column>
			<el-table-column
				:show-overflow-tooltip="true"
				:label="$t('privateNetInstance.listTitle.config')">
				<template slot-scope="scope">
					<span v-if="showDifferent.hasBandWith">{{scope.row.cpsConfiguration.cpu + ' | ' + scope.row.cpsConfiguration.mem + ' | ' + scope.row.cpsConfiguration.bw}} </span>
					<span v-else>{{scope.row.cpsConfiguration.cpu + ' | ' + scope.row.cpsConfiguration.mem}} </span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
export default {
	name: 'BatchInstanceTable',
	props: {
		multipleSelection: {
			type: Array,
			default: []
		},
		showDifferent: {
             type: Object,
		 	default: {
				 hasBandWith:true,
				 hasCollapse:true,
				 ipLabelType:'mainIp'


			 }
        }
	},
	data() {
		return {
			isCollapseTable: true
		};
	},
	methods: {
		collapseTable() {
			this.isCollapseTable = !this.isCollapseTable
		}
	}
};
</script>

<style lang="scss">
	.chooseInfo {
		margin-bottom: 5px;
		font-size: 12px;
		font-weight: 500;
		line-height: 1.5;
		color: #212121;
	}

	.el-table__body-wrapper {
	 	overflow: auto;
 	}
</style>



// WEBPACK FOOTER //
// src/components/common/BatchInstanceTable.vue